import { Column } from 'src/shared/components/Semantic/all'
import { Image } from 'src/shared/components/ui'

export const InvitePhoto = () => (
  <Column className="min-w-0 flex-1 justify-center bg-[hsl(220_16%_96%)] p-4">
    <div className="relative min-h-0 flex-1 overflow-hidden rounded-[1.25rem]">
      <Image
        src="/login/login-signup.webp?v=white"
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
    </div>
  </Column>
)
